export default class StringUtils {
	static randomId = () => {
		return Math.random().toString(36).substr(2, 15);
	}
}